import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('coupon');

/**
 * 获取优惠券列表
 * @param conditions
 * @returns {*}
 */
export function getCouponList(conditions) {
  return jrequest('list', conditions);
}

/**
 * 兑换优惠券
 * @param conditions code券码
 * @returns {*}
 */
export function exchangeCoupon(conditions) {
  return jrequest('exchange', conditions);
}

/**
 * 标记已读
 * @param conditions
 * @returns {*}
 */
export function readCoupon(conditions) {
  return jrequest('read', conditions);
}

/**
 * 领取优惠券
 * @param conditions
 * @returns {*}
 */
export function getCouponById(conditions) {
  if (!(conditions.couponId instanceof Array)) {
    conditions = { couponId: [conditions.couponId] };
  }
  return jrequest('receive', conditions, { method: 'post' });
}


/**
 * 获取链接领取优惠券信息
 * @param {*} conditions
 */
export function getLinkCouponInfo(conditions) {
  return jrequest('link', conditions);
}
